import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
import { Facebook, Instagram, LinkedIn, WhatsApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const FixedBottomNavigation = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: "primary.dark",
        color: "white",
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom translate="no">
              IT Engine Sparks
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {t("footer.description")}
            </Typography>
          </Grid>
          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}></Grid>
          {/* Social Media Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("footer.followUs")}
            </Typography>
            <Box>
              {[
                { href: "https://wa.me/526611301597", icon: <WhatsApp />, color: "#25D366", label: "WhatsApp" },
                { href: "https://www.facebook.com/profile.php?id=61569313564630", icon: <Facebook />, color: "#1877F2", label: "Facebook" },
                { href: "https://www.linkedin.com/in/carlosavilez/", icon: <LinkedIn />, color: "#0A66C2", label: "LinkedIn" },
                { href: "https://www.instagram.com/itenginesparks/", icon: <Instagram />, color: "#E4405F", label: "Instagram" },
              ].map(({ href, icon, color, label }) => (
                <IconButton
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  sx={{
                    color,
                    transition: "box-shadow 0.25s, transform 0.2s",
                    "&:hover": {
                      boxShadow: `0 0 14px 4px ${color}66`,
                      transform: "scale(1.15)",
                    },
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            mt: 4,
            pt: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="textSecondary" translate="no">
            {new Date().getFullYear()} IT Engine Sparks.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default FixedBottomNavigation;
